<script context="module">
	import Shop from './Shop.svelte'
	import CreateBlock from './CreateBlock.svelte'
	import Builder from './Builder.svelte'
	import UsrAdmin from '../builder/admin/Admin.svelte'
	import LinkedSite from './LinkedSite.svelte'

	export const routes = {
		'/': Builder,
		'/shop': Shop,
		'/createblock': CreateBlock,
		'/builder': Builder,
		'/usradmin': UsrAdmin,
		'/linksite': LinkedSite,
	}
</script>
